import { Injectable, WritableSignal, computed, signal } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class RoutingStateService {
  constructor() {}

  static returnUrl = '/';

  tabs = [{ name: 'dashboard', query: '' }];

  static newTabKey = '';

  static parentsQueryStrings = [];

  #resetTabName: WritableSignal<string> = signal('');
  resetTabName = computed(this.#resetTabName);

  setResetTabName(name: string) {
    this.#resetTabName.set(name);
  }

  removeTab(tabName: string) {
    this.tabs = this.tabs.filter((tab) => tab.name != tabName);
  }

  isChildQuery(query: string) {
    return query.includes('key-');
  }

  parseQueryString(query = '') {
    if (query == '') query = window.location.search;
    // Remove the leading '?' if present
    if (query.startsWith('?')) {
      query = query.substring(1);
    }

    // Split the query string into key-value pairs
    let pairs = query.split('&');
    let result = {};

    // Iterate over each pair
    pairs.forEach((pair) => {
      let [key, value] = pair.split('=');

      // Decode the key and value
      key = decodeURIComponent(key);
      value = decodeURIComponent(value);

      // Assign the decoded key-value pair to the result object
      result[key] = value;
    });

    return result;
  }

  // صفحاتی که میخوایم روتینگ روشون اعمال نشه
  exceptedPages: string[] = [
    '/smsTemplateGroup',
    '/phonebook',
    '/sendSMS',
    '/fastSendSmsPatternByPhonebook',
    '/roles',
    '/dynamicSendSms',
    '/surveyParser',
    '/competitionParser',
    '/textParsers',
  ];

  // صفحاتی که چند تا ازشون در تب ها باز میشن
  multipleTabs: string[] = ['sendReceivers','outboxTransactions','dynamicSendReceivers'];

isMultipleTabs(tabName){
  return this.multipleTabs.includes(tabName);
}

  isNotExceptedPages() {
    return !this.exceptedPages.includes(window.location.pathname);
  }

  newTabChilds: string[] = [
    '/smartDetail',
    '/informationUsersSeen',
    '/outboxTransactions',
    '/sendSmartDetailsByDelivery',
    '/sendReceivers',
  ];
  isNotNewTabChilds() {
    if (!this.newTabChilds.includes(window.location.pathname)) return true;
    else return false;
  }

  isHideRefreshBtnTabNames: string[] = [
    'outboxTransactions',
    'dynamicSendReceivers',
    'sendReceivers',
  ];

  isHideRefreshBtnList(tabName: string) {
    return this.isHideRefreshBtnTabNames.includes(tabName);
  }
}
